import { IssuesDashboard } from './issues/IssuesDashboard'

import type { GisOverview, GisScope } from '../../api/types'

interface IssuesTabContentProps {
  overview: GisOverview
  scope: GisScope
  activeMandals: readonly string[]
  onSelectIssue: (id: string, siteId: string | null) => void
  selectedIssueId: string | null
}

/**
 * District **Issues** lens (V5 toolbar layout). The list IS the tab: the search / Filters / Group /
 * view / Export controls live in the page-level `IssuesToolbar` (GisViewPage), the old Explore
 * Issues / Explore By analytical cards were removed with the V5 redesign (git history has them),
 * and the risk-sorted list fills the panel.
 */
export function IssuesTabContent({ scope, overview, activeMandals, onSelectIssue, selectedIssueId }: IssuesTabContentProps) {
  return (
    <IssuesDashboard
      scope={scope}
      sites={overview.sites}
      activeMandals={activeMandals}
      onSelectIssue={onSelectIssue}
      selectedIssueId={selectedIssueId}
    />
  )
}
